import React, { Component } from "react";
import { isIE } from 'react-device-detect';

// Constants
import { socketMessage } from "WEBSOCKET/constants";
import { CANVAS_TYPES, CANVAS_SOURCE, ANNOTATIONS } from "UTILS/Constants";

// String
import { getMessage } from "CONFIG/i18n";

// Styles 
import "./Canvas.less";

const CANVAS_HEIGHT = 805;
const CANVAS_WIDTH = 1435;

export default class Canvas extends Component {
  constructor(props) {
    super(props);
    this.commonCanvas = null;
    this.state = {
      canvasData: this.props.canvasData || []
    }
  }

  componentDidMount() {
    this.commonCanvas = new fabric.Canvas(this.props.canvasName, {
      selection: false,
      backgroundColor: "transparent",
      allowTouchScrolling: !isIE,
      defaultCursor: "auto",
      hoverCursor: "auto",
      isDrawingMode: true // enable drawing on canvas
    });

    // set canvas domensions
    this.setCanvasDimensions();
    
    // set values for free hand brush
    this.commonCanvas.freeDrawingBrush.width = ANNOTATIONS.FREE_HAND.WIDTH;
      
    this.commonCanvas.freeDrawingBrush.color = this.props.inkColor;

    this.commonCanvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
    this.resize(true);

    // draw canvas objects
    this.drawCanvasObjects();
    
    // add event listeners
    this.commonCanvas.on("path:created",async event => {

      // drawing mode is set to off to due double draw issue 
      await this.commonCanvas.set({
        isDrawingMode: false
      });
      let currentObject = event.path;
      currentObject["objectId"] =
        new Date().getTime() + this.props.participantId;
      currentObject["objectType"] = ANNOTATIONS.FREE_HAND.NAME;
      currentObject["lockScalingX"] =  true
      currentObject["lockScalingY"] =  true
      currentObject["lockRotation"] =  true
      currentObject["lockUniScaling"] =  true
      currentObject["lockScalingFlip"] =  true
      currentObject["lockMovementX"] = true
      currentObject["lockMovementY"] = true
      currentObject.set({ selectable: false });
      this.commonCanvas.discardActiveObject();
      this.commonCanvas.renderAll();
      this.commonCanvas.set({
        defaultCursor: "all-scroll",
        hoverCursor: "all-scroll",
        isDrawingMode: true
      });
      this.sendAddObjectMessage(currentObject, this.props.width);
    })

    window.addEventListener("resize", this.resize);

    const snapShotCanvas = document.getElementById("snapshotCanvas");
    if (snapShotCanvas) {
      const upperCanvas = snapShotCanvas.nextElementSibling;
      if(upperCanvas){
        upperCanvas.style.display = "none";
      }
    }
  }

  componentWillUnmount(){
    window.removeEventListener("resize", this.resize);
  }

  componentDidUpdate(prevProps, prevState) {
    // if(this.props.canvasData !== prevProps.canvasData) {
    //   this.setState({
    //     canvasData: this.props.canvasData
    //   })
    // }
    // resize canvas when video dimensions change
    if(((this.props.height/this.props.width).toFixed(2) 
      !== (prevProps.height/prevProps.width).toFixed(2))) {
    // if(this.props.height !== prevProps.height ||
    //   this.props.width !== prevProps.width) {
      setTimeout(() => {
        this.setCanvasDimensions();
        this.commonCanvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
        this.commonCanvas.freeDrawingBrush.width = ANNOTATIONS.FREE_HAND.WIDTH;
        this.resize(false, () => {
          this.commonCanvas.clear();
          this.drawCanvasObjects(true);
        });
      },1000)
    }

    if(this.props.lastDrawnObject !== prevProps.lastDrawnObject 
      && this.props.lastDrawnObject ) {
      // add last drawn object on canvas
      if(this.props.ownerOfLastAction !== this.props.participantId)
        this.addObjectToCanvas(
          this.props.lastDrawnObject.canvasObject, 
          this.props.lastDrawnObject.objectId, 
          this.props.lastDrawnObject.objectType, 
          (this.props.width / this.props.height > 1) ? CANVAS_WIDTH : CANVAS_HEIGHT,
          this.props.ownerOfLastAction,
          this.props.rotateY180)

      let lastDrawnObject = this.props.lastDrawnObject;
      lastDrawnObject.rotate = this.props.rotateY180;
      lastDrawnObject.participantId = this.props.ownerOfLastAction;
      let canvasData = this.state.canvasData;
      if(Array.isArray(canvasData)) {
        canvasData.push(lastDrawnObject)
      }
      this.setState({
        canvasData: canvasData
      })
    }

    // clear canvas
    if(this.props.canvasData !== prevProps.canvasData && (!this.props.canvasData || this.props.canvasData === {})) {
      this.setState({
        canvasData: []
      })
      this.commonCanvas.clear();
    }
  }
  
  setCanvasDimensions = () => {
    if(this.props.width / this.props.height > 1) { 
      // for landscape mode
      this.commonCanvas.setWidth(CANVAS_WIDTH);
      this.commonCanvas.setHeight(CANVAS_HEIGHT);
    } else {
      // for portrait mode
      this.commonCanvas.setWidth(CANVAS_HEIGHT);
      this.commonCanvas.setHeight(CANVAS_WIDTH);
    }
  } 

  drawCanvasObjects = (orientationChange) => {
    if(this.state.canvasData){
      let objectArray = this.getSortedCanvasData();
      console.log('objectArray: ', objectArray);
      if(objectArray.length < 1)
        this.props.hideSpinner();
      objectArray.forEach((object, index) => {
        if(object.canvasObject)
          object.canvasObject.strokeUniform = true;
        
        this.addObjectToCanvas(
          object.canvasObject,
          object.objectId,
          object.objectType,
          (this.props.width / this.props.height > 1) ? CANVAS_WIDTH : CANVAS_HEIGHT,
          object.participantId,
          object.rotate
        );
        if(index == objectArray.length-1)
          this.props.hideSpinner();
      });
    } else {
      this.props.hideSpinner();
    }
  }

  getSortedCanvasData = () => {
    const activeCanvasData = this.state.canvasData
    if (activeCanvasData) {
      let objectArray;
      objectArray = _.values(activeCanvasData);

      // sort canvas data on basis of updated time
      objectArray = _.orderBy(objectArray, ["updatedTime"], ["asc"]);

      return objectArray;
    }
  };

  addObjectToCanvas = (objectToAdd, objectId, objectType, width, participantId, flipX) => {
    fabric.util.enlivenObjects([objectToAdd], enlivenedObjects => {
      let newObject = enlivenedObjects[0];
      if (newObject) {
        newObject["strokeUniform"] = true;
        newObject["objectId"] = objectId;
        newObject["objectType"] = objectType;
        newObject["lockScalingX"] =  true
        newObject["lockScalingY"] =  true
        newObject["lockRotation"] =  true
        newObject["lockUniScaling"] =  true
        newObject["lockScalingFlip"] =  true
        newObject["lockMovementX"] = true
        newObject["lockMovementY"] = true
        
        if((
          this.props.rotateY180 && flipX
          && participantId !== this.props.participantId) || 
        (newObject["flipX"] && 
          participantId !== this.props.participantId
        )) {
          newObject["left"] = width - newObject["left"] - newObject["width"];
          newObject["flipX"] = true
        } else {
          newObject["flipX"] = false
        }
        this.commonCanvas.add(newObject);
      }
    });
  };

  sendAddObjectMessage = (object, width) => {
    //Add object to reducer

    let canvasObject = _.cloneDeep(object)
    if(this.props.rotateY180) {
      // canvasObject["left"] = width - canvasObject["left"] - canvasObject["width"];
      canvasObject["flipX"] = true
    }
    canvasObject["participantId"] = this.props.participantId
    const message = {
      data: {
        category: socketMessage.category.WHITEBOARD,
        action: socketMessage.subCategories.WHITEBOARD.ADD_OBJECT,
        sessionKey: this.props.sessionKey,
        canvasId: this.props.canvasId,
        canvasType: CANVAS_TYPES.REGULAR,
        activePage: -1,
        subAction: socketMessage.subCategories.WHITEBOARD.subActions.REGULAR,
        participantId: this.props.participantId,
        whiteboardData: {
          objectType: object.objectType,
          objectId: object.objectId,
          canvasObject: canvasObject
        },
        canvasSource: this.props.canvasSource
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
  };

  resize = (hideSpinner, call) => {
    let canvasContainer = document.getElementById("commonCanvasContainer");
    if (canvasContainer) {
      // var width = this.props.width;
      // var height = this.props.height;
      var width = canvasContainer.offsetWidth
      var height = canvasContainer.offsetHeight;

      var ratio = (this.commonCanvas.getWidth() / this.commonCanvas.getHeight()).toFixed(2);

      // find height/width of canvas depending on the containers height/width and 
      // original ratio of the canvas (ie. aspect ratio of the video)
      if (width / height > ratio) {
        width = height * ratio;
      } else {
        height = width / ratio;
      }

      var scale = width / this.commonCanvas.getWidth();
      var zoom = this.commonCanvas.getZoom();
      zoom *= scale.toFixed(3);
      
      this.commonCanvas.setDimensions({ width: width, height: height });
      
      // set zoom level of canvas so that the contents drawn on canvas maintain their position.
      this.commonCanvas.setViewportTransform([zoom, 0, 0, zoom, 0, 0]);
      this.commonCanvas.freeDrawingBrush.width = ANNOTATIONS.FREE_HAND.WIDTH;
      this.commonCanvas.renderAll();
      if(hideSpinner) this.props.hideSpinner();
      if(call) call();
    }
  }

  render() {
    return (
      <div className="commonCanvasContainer" id="commonCanvasContainer">
        <canvas id={this.props.canvasName}>
          {getMessage("CANVAS_NOT_SUPPORTED")}
        </canvas>
      </div>
    )
  }
}